import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-ink">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-mono text-xs tracking-[0.2em] uppercase text-signal mb-6">
              LEDOS Enterprise Solutions
            </p>
            <p className="font-display text-3xl md:text-4xl font-black tracking-tight leading-tight text-white max-w-md">
              Technology Installed. Connected. Configured. Supported.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="mt-8 inline-flex items-center gap-2 border border-line text-white font-mono text-xs tracking-[0.15em] uppercase px-5 py-3 hover:border-signal hover:text-signal transition-colors duration-300"
            >
              Start a Conversation
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-6">
              Services
            </p>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-sm text-zinc-400 hover:text-signal transition-colors duration-300"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-6">
              Company
            </p>
            <ul className="space-y-3">
              {[
                { to: "/about", label: "About LEDOS" },
                { to: "/industries", label: "Industries" },
                { to: "/services", label: "All Services" },
                { to: "/contact", label: "Contact" },
                { to: "/insights", label: "Insights" },
              ].map((l) => (
                <li key={l.to + l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-zinc-400 hover:text-signal transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-line overflow-hidden" aria-hidden="true">
        <p className="font-display text-[18vw] leading-[0.8] font-black tracking-tighter text-outline text-center select-none -mb-[3vw]">
          LEDOS
        </p>
      </div>

      <div className="border-t border-line">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-zinc-600">
            © {new Date().getFullYear()} LEDOS Enterprise Solutions
          </p>
          <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-zinc-600">
            IT Infrastructure // Deployment // Field Support
          </p>
        </div>
      </div>
    </footer>
  );
}
